export const JWT_CLAIMS = {
    Id: `Id`,
    Name: `http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name`,
    Role: `http://schemas.microsoft.com/ws/2008/06/identity/claims/role`,
    Expiry: "exp",
    IsSSO: "isSSO",
};
